import gql from "graphql-tag";

export const ACCEPT_PROJECT_INVITE = gql`
  mutation($input: acceptProjectInvite) {
    acceptProjectInvite(input: $input)
  }
`;
